import { ReactNode } from 'react';
import React from 'react';
import RoleManagement from './RoleManagement';
import UserManagement from '.';

interface TabsData {
  [key: string]: ReactNode;
}
export const tabsData :TabsData ={
    'All Users':<UserManagement/>,
    'Roles':<RoleManagement/>,
    'Analytics':<div>Analytics</div>
}